import { GraphQLClient, RequestMiddleware, ResponseMiddleware, Variables } from "graphql-request";

export type BaseGqlClientType = {
  requestMiddleware?: RequestMiddleware<Variables>;
  responseMiddleware?: ResponseMiddleware;
};

export class BaseGqlClient {
  public client: GraphQLClient;
  constructor(url: string, config?: BaseGqlClientType) {
    this.client = new GraphQLClient(url, {
      credentials: "include",
      mode: "cors",
      ...(config?.requestMiddleware && { requestMiddleware: config.requestMiddleware }),
      ...(config?.responseMiddleware && { responseMiddleware: config.responseMiddleware }),
    });
  }
}

export const createGqlClient = (useServer?: boolean, config?: BaseGqlClientType) =>
  new BaseGqlClient(
    (useServer ? process.env.NEXT_PUBLIC_SSR_URL_SERVER_GRAPHQL : process.env.NEXT_PUBLIC_URL_SERVER_GRAPHQL) as string,
    config,
  );
